<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Live chat",
    "pageDesc":"Chat with Baianat team and get the support needed across our services and products.",
    "mantra":"Get instant| support.",
    "sec1Items":{
      "1":{
        "title":"Real time responses",
        "desc":"We help you with instant and reliable support based on your questions and concerns."
      },
      "2":{
        "title":"Friendly interface",
        "desc":"Designed with your needs in mind so you could access your resources or get in touch without having doubts."
      },
      "3":{
        "title":"Only humans",
        "desc":"No automation or auto-replies. Our support team is always behind the screen to help you with your concerns."
      }
    },
    "sec2":"Have everything done LIVE!",
    "sec2Items":{
      "1":{
        "title":"Open tickets",
        "desc":"Chat with our support team and get your project issues solved."
      },
      "2":{
        "title":"Manage your account",
        "desc":"Manage your Baianat account information and restore it in case of loss."
      },
      "3":{
        "title":"Track your projects",
        "desc":"Get the latest updates with your project status and modify your scope."
      },
      "4":{
        "title":"Ask us anything!",
        "desc":"Enquire about Baianat products and services in a blin"
      }
    },
    "cta":"Chat with us"
  },
  "ar": {
    "pageTitle":"المحادثة المباشرة",
    "pageDesc":"تحدث مع فريق بيانات في أي وقت واحصل على الدعم اللازم عبر خدماتنا ومنتجاتنا.",
    "mantra":"احصل على |الدعم الفوري.",
    "sec1Items":{
      "1":{
        "title":"الردود في الوقت المثالي",
        "desc":"نساعدك من خلال دعم فوري وفقًا إلى أسئلتك واهتماماتك حول أي شيء يشغل بالك."
      },
      "2":{
        "title":"واجهة أمامية بسيطة",
        "desc":"صممنا الواجهة الأمامية مع الأخذ في الاعتبار جميع الاحتياجات لتتمكن من الوصول إلى جميع الموارد التي تحتاج إليها."
      },
      "3":{
        "title":"تواصل بشري",
        "desc":"لا نعتمد على الردود الألية أو الأتمتة. يتم الإجابة عليك على الفور من خلال فريقنا؛ لتعرف ردود كل ما يدور في بالك. "
      }
    },
    "sec2":"احصل على كل شيء في الحال.",
    "sec2Items":{
      "1":{
        "title":"فتح التذاكر",
        "desc":"تحدث مع فريق الدعم الخاص بنا واحصل على حل لكل مشكلات مشروعك."
      },
      "2":{
        "title":"إدارة حسابك",
        "desc":"يمكنك إدارة معلومات حساب بيانات واستعادته إذا فقدته في أي وقت."
      },
      "3":{
        "title":"تتبع مشاريعك",
        "desc":"تستطيع الحصول على آخر التحديثات لحالة المشروع وتعديل نطاقك."
      },
      "4":{
        "title":"أسألنا أي شيء!",
        "desc":"استفسر عن منتجات وخدمات بيانات واحصل على الإجابة على الفور."
      }
    },
    "cta":"تحدث معنا في<br> أي وقت."
  }
}
</i18n>
